import { useEffect, useRef, useState } from "react";

function useSticky() {
  const ref = useRef<HTMLDivElement>(null);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = new IntersectionObserver(
      ([event]) => {
        setIsSticky(event.intersectionRatio < 1);
      },
      {
        threshold: [1],
        rootMargin: "0px 1px 1px 1px",
        root: document.querySelector(".dashboard-content"),
      }
    );
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return { ref, isSticky };
}

export default useSticky;
